<template>
  <div class="commentItemBox">
    <el-avatar :size="30" :src="$oss + item.empAvatar" class="avatar" />
    <div class="content">
      <div class="top">
        <div class="username">{{ item.empName }}</div>
        <div class="icon" v-if="item.empIsAuthor">发布者</div>
        <template v-if="[1, 2].includes(item.type)">
          <div class="text">回复</div>
          <div class="username">{{ item.targetEmpName }}</div>
        </template>
      </div>
      <div class="center">
        {{ item.content }}
      </div>
      <div class="bottom">
        <div class="time">{{ renderTime(item.createdAt) }}</div>
        <div class="reply" @click="onComment">·回复</div>
      </div>
      <div class="slot">
        <slot :commentList="item.commentList"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {
  },
  methods: {
    ...mapActions("information", ["setTarget"]),
    renderTime(time) {
      dayjs.locale("zh-cn");
      dayjs.extend(relativeTime);
      const timestamp = time * 1000; // 转换为毫秒
      const fromNow = dayjs(timestamp).fromNow();
      return fromNow;
    },
    onComment() {
      this.setTarget(this.item);
      console.log(this.item);
    },
  },
};
</script>

<style scoped lang="scss">
.commentItemBox {
  display: flex;
  .avatar {
    flex-shrink: 0;
  }
  .content {
    padding-left: 10px;
    .top {
      display: flex;
      align-items: center;
      gap: 4px;
      .username {
        font-size: 16px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;
        color: #0062ff;
      }
      .icon {
        width: 42px;
        height: 18px;
        border-radius: 4px;
        display: flex;
        border: 1px solid #eeeeee;
        align-items: center;
        justify-content: center;

        font-size: 10px;
        line-height: 10px;
        letter-spacing: 0em;
        color: #999999;
      }
      .text {
        font-size: 16px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;
        color: #999999;
      }
    }
    .center {
      flex: 1; /* 占据剩余空间 */
      word-break: break-word; /* 防止英文长单词溢出 */
      margin-top: 4px;

      font-size: 14px;
      line-height: 24px;
      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #262626;
    }
    .bottom {
      display: flex;
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      .time {
        color: #999999;
      }
      .reply {
        color: #666666;
        cursor: pointer;
        &:hover {
          color: #0062ff;
        }
      }
    }
    .slot {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }
}
</style>
